<template>
  <div class="container">
    <h1>Packages</h1>
    <b-row>
      <b-col>
        <b-form class="d-flex mb-2" inline @submit.prevent>
          <b-form-select
            id="packages__perPage"
            class="mb-0"
            v-model="perPage"
            :options="perPageOptions"
            aria-label="Per page"
            aria-controls="packages-table"
          ></b-form-select>
          <b-form-input
            id="packages__searchQuery"
            class="ml-sm-2 col-md-2 mb-0"
            v-model="searchQuery"
            placeholder="Search..."
            aria-label="Search"
            aria-controls="packages-table"
          ></b-form-input>
          <router-link
            v-if="packages.length"
            class="ml-auto btn btn-primary"
            :to="{ name: 'packages/add' }"
          >
            Add Package
          </router-link>
        </b-form>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table
          id="packages__table"
          :items="packages"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :filter="searchQuery"
          :per-page="perPage"
          :current-page="currentPage"
          :busy="loading"
          :show-empty="!loading && !packages.length"
          stacked="md"
          striped
          @filtered="
            filteredItems => (searchItemsLength = filteredItems.length)
          "
        >
          <template v-slot:cell(name)="data">
            <router-link
              tag="a"
              :to="{ name: 'packages/edit', params: { id: data.item._id } }"
              >{{ data.item.name }}</router-link
            >
          </template>
          <template v-slot:cell(actions)="data">
            <b-button
              size="sm"
              variant="link"
              class="m-0 p-0 text-muted"
              @click.prevent="confirmDeletePackage(data.item)"
            >
              <i class="fa fa-trash"></i>
            </b-button>
          </template>
          <template v-slot:table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>
          <template v-slot:empty>
            <div v-if="error" class="text-center text-danger my-2">
              <p>Something went wrong, please try again later.</p>
            </div>
            <div v-else class="text-center text-primary my-2">
              <p>You don't have any Packages yet.</p>
              <router-link
                :to="{ name: 'packages/add' }"
                class="btn btn-primary"
              >
                Add a Package
              </router-link>
            </div>
          </template>
        </b-table>
        <b-pagination
          id="packages__pagination"
          v-model="currentPage"
          :total-rows="packages.length"
          :per-page="perPage"
          align="right"
          aria-controls="packages-table"
          first-number
          last-number
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { timestampToDateAndTime } from '@/time';

export default {
  name: 'AdminPackages',
  data() {
    return {
      loading: true,
      error: null,
      fields: [
        {
          key: 'name',
          label: 'Name',
          sortable: true
        },
        {
          key: 'timestamp',
          label: 'Last Modified',
          sortable: true,
          formatter: timestampToDateAndTime
        },
        {
          key: 'actions',
          label: '',
          sortable: false
        }
      ],
      searchQuery: null,
      searchItemsLength: 0,
      sortBy: 'name',
      sortDesc: false,
      perPage: 5,
      currentPage: 1,
      perPageOptions: [5, 10, 25, 50]
    };
  },
  methods: {
    ...mapActions({
      fetchPackages: 'packages/fetchPackages',
      deletePackage: 'packages/deletePackage'
    }),
    async confirmDeletePackage(_package) {
      let result = await this.$swal({
        type: 'warning',
        title: 'Are you sure?',
        text: `The package "${_package.name}" will be permanently deleted.`,
        showCancelButton: true
      });

      if (!result.value) return;

      try {
        await this.deletePackage(_package);
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'Package deleted.'
        });
      } catch (e) {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: e.message
        });
      }
    }
  },
  computed: mapGetters({
    packages: 'packages/packagesList'
  }),
  async created() {
    try {
      await this.fetchPackages();
    } catch (e) {
      this.error = e.message;
    } finally {
      this.loading = false;
    }
  }
};
</script>
